import React from 'react';
import Hero from '../hero/Hero';
import Details from '../details/Details';
import Faq from '../faq/Faq';
import Footer from '../footer/Footer';
import AboutUs from '../about/AboutUs';
import Testimonials from '../testimonials/Testimonials';
import CarouselSection from '../carousel/CarouselSection';

const HomePage = () => {
    return (
        <main style={{position: 'relative'}}>
            <Hero />
            <Details />
            <CarouselSection />
            <Testimonials />
            <Faq />
            <AboutUs />
            <Footer />
        </main>
    );
}


export default HomePage;
